import { Injectable, inject } from '@angular/core';
import { TslApiService } from 'projects/aztalena-core/src/public-api';
import { Observable } from 'rxjs';
import { Gift } from './gift';

@Injectable({
  providedIn: 'root'
})
export class GiftService {
  private api = inject(TslApiService);

  getGifts(): Observable<Gift[]> {
    return this.api.get('gift/all');
  }
}
